import {useSortable} from "@dnd-kit/sortable";
import React from "react";
import {CSS} from "@dnd-kit/utilities";
import {Badge, Form} from "react-bootstrap";
import {
    DocumentTemplateSectionType,
    IDocumentTemplateSection
} from "../../../shared/interfaces/document-template/IDocumentTemplate";


interface SortableRowProps {
    section: IDocumentTemplateSection;
    onEdit: (s: IDocumentTemplateSection) => void;
    onDelete: (id: number) => void;
    onToggleEnabled: (s: IDocumentTemplateSection) => void;
    t: any;
}
const sectionTypeBadgeColor = (type: DocumentTemplateSectionType): string => {
    const map: Record<DocumentTemplateSectionType, string> = {
        COVER_PAGE: "primary",
        INTRO: "info",
        ITEMS_TABLE: "secondary",
        TOTALS: "warning",
        PAYMENT_TERMS: "success",
        FOOTER_INFO: "dark",
    };
    return map[type] ?? "secondary";
};
export const SortableRow = ({ section, onEdit, onDelete, onToggleEnabled, t }: SortableRowProps) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: section.id,
    });
    const style: React.CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        background: isDragging ? "#f8f9fa" : undefined,
    };

    return (
        <tr ref={setNodeRef} style={style}>
            <td style={{ width: 36, cursor: "grab" }} {...attributes} {...listeners}>
                <i className="ti ti-grip-vertical text-muted f-18"></i>
            </td>
            <td>
                <Badge bg={sectionTypeBadgeColor(section.type)}>{section.type}</Badge>
            </td>
            <td>
                <Form.Check
                    type="switch"
                    checked={section.isEnabled}
                    onChange={() => onToggleEnabled(section)}
                    label=""
                />
            </td>
            <td>
                <small className="text-muted font-monospace">
                    {section.content
                        ? section.content.substring(0, 60) + (section.content.length > 60 ? "\u2026" : "")
                        : "\u2014"}
                </small>
            </td>
            <td className="text-end">
                <ul className="list-inline mb-0">
                    <li className="list-inline-item" onClick={() => onEdit(section)}>
                        <span className="avtar avtar-s btn-link-success btn-pc-default" role="button">
                            <i className="ti ti-edit f-20"></i>
                        </span>
                    </li>
                    <li className="list-inline-item" onClick={() => onDelete(section.id)}>
                        <span className="avtar avtar-s btn-link-danger btn-pc-default" role="button">
                            <i className="ti ti-trash f-20"></i>
                        </span>
                    </li>
                </ul>
            </td>
        </tr>
    );
};
